import { render, staticRenderFns } from "./SumTV.vue?vue&type=template&id=abcc3528&scoped=true&"
import script from "./SumTV.vue?vue&type=script&lang=js&"
export * from "./SumTV.vue?vue&type=script&lang=js&"
import style0 from "./SumTV.vue?vue&type=style&index=0&id=abcc3528&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abcc3528",
  null
  
)

export default component.exports